import { Icon } from "@opendash/icons";
import { Button, Flex, Tooltip, Typography } from "antd";
import React from "react";

export default (props: { title: string; info: string }) => {
  return (
    <Flex gap="8px" align="center">
      <Typography.Text>{props.title}</Typography.Text>
      <Tooltip title={props.info}>
        <Button shape="circle" size="small">
          <Icon icon="fa:question" type="round" />
        </Button>
      </Tooltip>
    </Flex>
  );
};
